const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return Number(num).toLocaleString();
};

const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '0 Ar';
  return `${Number(amount || 0).toLocaleString()} Ar`;
};

const KpiCard = ({ label, value, delta, deltaSuffix }) => (
  <div className="kpi-card">
    <span>{label}</span>
    <strong>{value}</strong>
    <small>
      {delta ? (
        <>
          <i className="fa-solid fa-arrow-trend-up" /> {delta} <em>{deltaSuffix || 'vs période précédente'}</em>
        </>
      ) : (
        <em>{deltaSuffix || 'cumulé'}</em>
      )}
    </small>
  </div>
);

const AnalyticsKPI = ({ data, loading }) => {
  if (loading) {
    return (
      <>
        {['Écoutes', 'Ventes', 'Revenus', 'Albums'].map((label) => (
          <div key={label} className="kpi-card">
            <span>{label}</span>
            <strong>…</strong>
            <small><em>Chargement</em></small>
          </div>
        ))}
      </>
    );
  }

  const streams = data?.streams || {};
  const sales = data?.sales || {};
  const albums = data?.albums || {};

  return (
    <>
      <KpiCard
        label="Écoutes"
        value={formatNumber(streams.total || 0)}
        delta={streams.this_month ? `+${formatNumber(streams.this_month)}` : null}
        deltaSuffix="ce mois"
      />
      <KpiCard
        label="Ventes"
        value={formatNumber(sales.total || 0)}
        delta={sales.this_month ? `+${formatNumber(sales.this_month)}` : null}
        deltaSuffix="ce mois"
      />
      <KpiCard
        label="Revenus"
        value={formatCurrency(sales.total_revenue)}
        delta={null}
        deltaSuffix="cumulé"
      />
      <KpiCard
        label="Albums"
        value={formatNumber(albums.published || 0)}
        delta={albums.total ? `${formatNumber(albums.total)}` : null}
        deltaSuffix="au total"
      />
    </>
  );
};

export default AnalyticsKPI;
